import { GVariantBadge } from '~/presentation/ui';

interface IExperimentsCellVersionProps {
  version: string;
}

export const CampaignsCellVersion = ({ version }: IExperimentsCellVersionProps) => {
  if (!version) return null;

  return (
    <GVariantBadge variant={version} tone={version === 'A' ? 'active' : 'inactive'} size="xs" />
  );
};
